import { useReportDetailStore } from "./store";

export const useReportSections = () =>
  useReportDetailStore((state) => state.data.sections);

export const useReportDeletedSections = () =>
  useReportDetailStore((state) => state.data.deletedSections);

export const useReportMetadata = () =>
  useReportDetailStore((state) => state.data.metadata);

export const useReportFolderId = () =>
  useReportDetailStore((state) => state.data.metadata?.folder_id ?? null);

export const useReportType = () =>
  useReportDetailStore((state) => state.data.reportType);

export const useReportProfileImage = () =>
  useReportDetailStore((state) => state.data.profileImage);

export const useSelectedCombinedFilter = () =>
  useReportDetailStore((state) => state.data.selectedCombinedFilter);

export const useCombinedReportSources = () =>
  useReportDetailStore((state) => state.data.combinedReportSources);

export const useReportSectionListRecords = () =>
  useReportDetailStore((state) => state.ui.sectionListRecords);

export const useRelacoesSectionList = () =>
  useReportDetailStore((state) => state.ui.relacoesSectionList);

export const useTotalRecords = () =>
  useReportDetailStore((state) => state.ui.totalRecords);

export const useReportReloadTrigger = () =>
  useReportDetailStore((state) => state.ui.reloadTrigger);

export const useIsActionLoading = () =>
  useReportDetailStore((state) => state.ui.isActionLoading);

export const useActiveSection = () =>
  useReportDetailStore((state) => state.ui.activeSection);

export const useIsScrollLoading = () =>
  useReportDetailStore((state) => state.ui.isScrollLoading);

export const useAccordionToggle = () =>
  useReportDetailStore((state) => state.ui.accordionToggle);

export const usePendingScrollTarget = () =>
  useReportDetailStore((state) => state.ui.pendingScrollTarget);

export const useOpenSections = () =>
  useReportDetailStore((state) => state.ui.openSections);

export const useOpenSectionsTrash = () =>
  useReportDetailStore((state) => state.ui.openSectionsTrash);

export const useIsPendingSave = () =>
  useReportDetailStore((state) => state.autoSave.isPending);

export const useHasPendingChanges = () =>
  useReportDetailStore((state) => state.autoSave.hasPendingChanges);

export const useIsAutoSaveEnabled = () =>
  useReportDetailStore((state) => state.autoSave.isEnabled);

export const useActiveRelacaoTab = () =>
  useReportDetailStore((state) => state.ui.activeRelacaoTab);

export const useHighlightedEntityId = () =>
  useReportDetailStore((state) => state.ui.highlightedEntityId);

export const useRefetchReport = () =>
  useReportDetailStore((state) => state.ui.refetchReport);

export const useSummaryData = () =>
  useReportDetailStore((state) => state.data.summaryData);

export const useSummaryStatus = () =>
  useReportDetailStore((state) => state.data.summaryStatus);

export const useSectionsWithSummary = () =>
  useReportDetailStore((state) => state.data.sectionsWithSummary);

export const useReportDetailActions = () =>
  useReportDetailStore((state) => state.actions);